import { ITopolPageProps } from '@/types/TopolPageProps/TopolPageProps';
import { usePage } from '@inertiajs/vue3';
import { computed } from 'vue';

import { Code, CogIcon, CreditCardIcon, ShieldCheck, UsersIcon } from "lucide-vue-next"
import { ILink } from '@/types/Atomic/ISidebarData';

export default () => {
    const globalProps = computed(() => usePage<ITopolPageProps>().props);
    const isPersonalTeam = computed(() => globalProps.value.team.personal_team);
    const { subscriptionRouteName } = useSubscriptionLabel();
    const { membersCount } = useTeamsAndMembers();

    const linksPlugin = computed((): ILink[] => {
        // Plugin (api-tokens) is personal-team-scoped — hide it on non-personal teams.
        const links: ILink[] = [];

        if (isPersonalTeam.value) {
            links.push({
                name: 'API Tokens',
                href: route('plugin.api-tokens.index'),
                icon: Code,
                count: undefined,
                id: '/plugin',
            });
        }

        links.push({
            name: 'Members',
            href: route('members.index'),
            icon: UsersIcon,
            count: membersCount.value,
            id: '/members',
        });

        if (
            globalProps.value.team_role.key === 'owner' ||
            globalProps.value.team_role.key === 'admin' ||
            globalProps.value.team_role.key === 'editor'
        ) {
            links.push({
                name: 'Settings',
                href: route('settings.profile-settings.index'),
                icon: CogIcon,
                count: undefined,
                id: '/settings',
            });
        }

        if (globalProps.value.team_role.key === 'owner') {
            links.push({
                name: 'Billing',
                href: route(subscriptionRouteName.value),
                icon: CreditCardIcon,
                count: undefined,
                id: '/billing/',
            });
        }

        if (globalProps.value.isAdmin) {
            links.push({
                name: 'Kiosk',
                href: route('kiosk.dashboard.index'),
                icon: ShieldCheck,
                count: undefined,
                id: '/kiosk',
            });
        }

        return links;
    });

    return {
        links: linksPlugin,
    };
};
